import React, { useEffect, useState } from "react";
import { Moment } from "moment";

import { TablePagination, LabMachineAnalysisFiletersForm } from "../..";
import { SAMPLE_ANALYSIS_TABLE } from "../../../utils/constants";
import { Sample } from "./types";
import { applyFilter } from "./applyFilter";

export function Table({ data }: { data: Sample[] }): any {
  const [dataToShow, setDataToShow] = useState<
    {
      machine: string;
      samples: { id: string; date: string; state: string }[];
    }[]
  >([]);

  useEffect(() => {
    setDataToShow([]);
  }, [data]);

  const handleFilter = (form: {
    sampleDates: [null | Moment, null | Moment];
    states: string[];
    machines: string[];
  }) => {
    const dataFiltered = applyFilter(data, form);
    setDataToShow(dataFiltered);
  };

  const getTableContentStyle = (col, v) => {
    if (col === "estado") {
      if (v === "NORMAL")
        return {
          backgroundColor: "rgba(0,255,0,.3)",
        };
      if (v === "PRECAUCION")
        return {
          backgroundColor: "rgba(255,246,0,.3)",
        };
      if (v === "CRITICO")
        return {
          backgroundColor: "rgba(255,0,0,.3)",
        };
    }
  };

  return (
    <>
      <LabMachineAnalysisFiletersForm
        registers={data}
        onSubmit={handleFilter}
      />

      <TablePagination
        data={dataToShow as any}
        headers={SAMPLE_ANALYSIS_TABLE.HEADERS}
        style={{ marginTop: "3%" }}
        getContentStyle={getTableContentStyle}
      />
    </>
  );
}
